import { State } from "../reducers/root";

export const getOfficebyId = (officeId: number) => {
  return (state: State) => {
    const office = state.offices.data.filter((office) => office.id === officeId)[0];
    return office;
  };
};
